var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('AppInfoTextBlock',{attrs:{"label-text":_vm.labelText,"text":_vm.currentText,"is-link":_vm.isLink,"href":_vm.href,"is-router-link":_vm.isRouterLink,"route":_vm.route}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }